import styled from 'styled-components';

import { 
  WIDTH_SIDE_BAR,
  PADDING_BTN_SIDE_BAR, 
  BACKGROUND_SIDE_BAR,
  COLOR_BTN_SIDE_BAR,
  FONT_BTN_SIDE_BAR_ICON,
  FONT_BTN_SIDE_BAR_STEP,
  FONT_BTN_SIDE_BAR_TITLE,
  FONT_BTN_SIDE_BAR_ICON_MOBILE,
} from '../../../globals';

export const StyledBtnSideBar = styled.div`
  width: ${WIDTH_SIDE_BAR}px;
  
  ${props => props.isActive ? 'background-color:' + COLOR_BTN_SIDE_BAR + ';' : ''}
  ${props => props.isActive ? 'border-right: 1px solid white;' : ''}
  
  padding: ${PADDING_BTN_SIDE_BAR}px 0px ${PADDING_BTN_SIDE_BAR}px 0px;
  text-align: center;  

  .btn-sidebar-link {
    display: block;
    text-decoration: none;
    cursor: ${props => props.enableClick ? 'pointer' : 'default'};
  }

  .btn-sidebar-link:hover, .btn-sidebar-link:visited, .btn-sidebar-link:active {
    text-decoration: none;
  }

  .btn-sidebar-content {
    color: ${props => props.isActive ? BACKGROUND_SIDE_BAR : COLOR_BTN_SIDE_BAR};
  }

  .btn-sidebar-icon {
    font-size: ${FONT_BTN_SIDE_BAR_ICON}em;
  }

  .btn-sidebar-step {
    font-size: ${FONT_BTN_SIDE_BAR_STEP}em;
    font-weight: 700;
    padding-bottom: 3px;
  }

  .btn-sidebar-title {
    font-size: ${FONT_BTN_SIDE_BAR_TITLE}em;
    font-weight: 700;
    text-transform: uppercase;
  }

  
  @media (max-width: 767px) {
    width: auto;
    border-right: none;
    height: 100%;
    padding: 0px;

    .btn-sidebar-icon {
      font-size: ${FONT_BTN_SIDE_BAR_ICON_MOBILE}em;
      height: 100%;
      padding-top: ${PADDING_BTN_SIDE_BAR}px;
    }

    .btn-sidebar-step {
      display: none;
    }

   .btn-sidebar-title {
      display: none;
    }
  }

`;
